import { IFlexItem } from 'core-components/sitebuilder/models/flexGrid/IFlexItem'

class FlexLayoutSetCollectionClass {
  private data: { [key: number]: IFlexItem[] } = {}

  add(id: number, items: IFlexItem[]) {
    this.data[id] = items
  }

  get(id: number) {
    return this.data[id]
  }

  remove(id: number) {
    delete this.data[id]
  }
}

export const FlexLayoutSetCollection = new FlexLayoutSetCollectionClass()
